import { Module } from '@/modules/core/app/constants/app.constants';
import { CatalogueRoutes } from '@/modules/to/order/order.constants';
import { CatalogPageRouteConfig } from '@/modules/to/order/catalogPageRouteConfig';

export const router = CatalogPageRouteConfig.factory(
  [
    {
      path: 'cataloguepage',
      name: CatalogueRoutes.LIST_PAGE,
      component: () => import(/* webpackChunkName: "cataloguepage" */ './pages/ProductListPage'),
    },
    {
      path: 'cataloguepage/cart/:id',
      name: CatalogueRoutes.CART_PAGE,
      component: () => import(/* webpackChunkName: "cataloguepage-cart-edit" */ './pages/CartPage'),
    },
    {
      path: 'cataloguepage/:formType/:id',
      name: CatalogueRoutes.PRODUCT_DETAILS_PAGE,
      component: () =>
        import(
          /* webpackChunkName: "cataloguepage-product-details" */ './pages/ProductDetailsPage'
        ),
    },
  ],
  Module.CATALOGUESETTING
);
